import React from 'react';

const UncheckedIcon = class extends React.Component {
	render() {
		return (
			<svg fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 1 32 32" style={this.props.style||{}}>
				<path d="M23.5,5H8.5A3.50424,3.50424,0,0,0,5,8.5v15A3.50424,3.50424,0,0,0,8.5,27h15A3.50424,3.50424,0,0,0,27,23.5V8.5A3.50424,3.50424,0,0,0,23.5,5ZM24,23.5a.50641.50641,0,0,1-.5.5H8.5a.50641.50641,0,0,1-.5-.5V8.5A.50641.50641,0,0,1,8.5,8h15a.50641.50641,0,0,1,.5.5Z"/>
			</svg>
		);
	}
}

export default UncheckedIcon;
